import {ProfileReference} from '@github-ui/profile-reference'
import {TrashIcon} from '@primer/octicons-react'
import {Link} from '@primer/react'

import {LABELS} from '../constants/labels'
import {createIssueEventExternalUrl} from '../utils/urls'
import styles from './CommentDeletedEvent.module.css'
import type {CommentDeletedEventNode} from './issue-viewer-page-query-types'
import {TimelineRow} from './row/TimelineRow'

export type CommentDeletedEventFragment = Pick<
  CommentDeletedEventNode,
  'actor' | 'createdAt' | 'databaseId' | 'deletedCommentAuthor'
>

type CommentDeletedEventProps = {
  queryRef: CommentDeletedEventFragment
  issueUrl: string
  onLinkClick?: (event: MouseEvent) => void
  highlightedEventId?: string
  refAttribute?: React.RefObject<HTMLLIElement | null>
}

export function CommentDeletedEvent({
  queryRef,
  issueUrl,
  onLinkClick,
  highlightedEventId,
  refAttribute,
}: CommentDeletedEventProps): React.ReactElement {
  const {actor, createdAt, deletedCommentAuthor, databaseId} = queryRef

  const highlighted = String(databaseId) === highlightedEventId
  const deletedCommentAuthorLogin = deletedCommentAuthor?.login
  const deletedCommentAuthorName =
    deletedCommentAuthor && 'name' in deletedCommentAuthor ? deletedCommentAuthor.name : null

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
      onLinkClick={onLinkClick}
      leadingIcon={TrashIcon}
    >
      <TimelineRow.Main>
        {`${LABELS.timeline.deletedACommentFrom} `}
        <Link href={`/${deletedCommentAuthorLogin}`} inline className={styles.deletedCommentAuthorLink}>
          <ProfileReference
            login={deletedCommentAuthorLogin ?? ''}
            profileName={deletedCommentAuthorName}
            isAgent={false}
          />
        </Link>{' '}
      </TimelineRow.Main>
    </TimelineRow>
  )
}
